// below error codes are also defined in iam/auth/console/error_codes.py, please not modify the values
export const ERROR_INVITE_CODE_EXPIRED_AND_RESENT = 1000
export const ERROR_INVITE_CODE_EXPIRED = 1001
export const ERROR_VERIFICATION_CODE_EXPIRED = 1002
export const ERROR_CODE_EXPIRED = 1005
export const ERROR_ACCOUNT_NOT_FOUND = 1007
export const ERROR_INVITE_CODE_EXPIRED_NO_SEAT = 1008

export const FULL_PAGE_ERROR_CODES = [
  ERROR_INVITE_CODE_EXPIRED_AND_RESENT,
  ERROR_INVITE_CODE_EXPIRED,
  ERROR_ACCOUNT_NOT_FOUND,
  ERROR_INVITE_CODE_EXPIRED_NO_SEAT,
]
